"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIdSwiper = _interopRequireDefault(require("react-id-swiper"));
require("swiper/css/swiper.css");
var _resizeObserverPolyfill = _interopRequireDefault(require("resize-observer-polyfill"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Loader = _interopRequireDefault(require("../../icons-react/rebrand/Loader"));
var _userflow = require("../../utils/userflow");
var _excluded = ["children", "imageHeight", "imageWidth", "images", "onClickGallery", "id"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ArrowIcon = function ArrowIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 14.9L37 65l-21 50.1"
  }));
};
ArrowIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 53 130",
  fill: "none",
  stroke: "#fff",
  strokeWidth: "3",
  strokeLinecap: "round"
};
var settings = {
  slidesPerView: 'auto',
  swipe: true,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-custom-next',
    prevEl: '.swiper-button-custom-prev'
  },
  renderPrevButton: function renderPrevButton() {
    return /*#__PURE__*/_react["default"].createElement(StyledArrowIcon, {
      className: "swiper-button-custom-prev",
      type: "prev"
    });
  },
  renderNextButton: function renderNextButton() {
    return /*#__PURE__*/_react["default"].createElement(StyledArrowIcon, {
      className: "swiper-button-custom-next",
      type: "next"
    });
  },
  lazy: {
    loadPrevNext: true,
    preloaderClass: 'swiper-lt-preloader',
    loadPrevNextAmount: 2
  },
  watchSlidesVisibility: true
};
var MobileRoomGallery = /*#__PURE__*/function (_React$PureComponent) {
  function MobileRoomGallery(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, MobileRoomGallery);
    _this = _callSuper(this, MobileRoomGallery, [props]);
    _this.wrapperRef = /*#__PURE__*/_react["default"].createRef();
    _this.state = {
      slidesToShow: 1,
      infinite: true
    };
    return _this;
  }
  (0, _inherits2["default"])(MobileRoomGallery, _React$PureComponent);
  return (0, _createClass2["default"])(MobileRoomGallery, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.observer = new _resizeObserverPolyfill["default"](this.calculateItemsToShow.bind(this));
      this.observer.observe(this.container);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.observer) {
        this.observer.unobserve(this.container);
      }
    }
  }, {
    key: "container",
    get: function get() {
      return (0, _get2["default"])(this, 'wrapperRef.current');
    }
  }, {
    key: "containerWidth",
    get: function get() {
      return (0, _get2["default"])(this.container, 'clientWidth');
    }
  }, {
    key: "calculateItemsToShow",
    value: function calculateItemsToShow() {
      var containerWidth = this.containerWidth;
      var _this$props = this.props,
        imageWidth = _this$props.imageWidth,
        images = _this$props.images;
      var slidesToShow = containerWidth / imageWidth;
      var infinite = slidesToShow < images.length;
      this.setState({
        slidesToShow: slidesToShow,
        infinite: infinite
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        imageHeight = _this$props2.imageHeight,
        imageWidth = _this$props2.imageWidth,
        images = _this$props2.images,
        onClickGallery = _this$props2.onClickGallery,
        id = _this$props2.id,
        rest = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      return /*#__PURE__*/_react["default"].createElement(StyledContainer, (0, _extends2["default"])({}, rest, {
        ref: this.wrapperRef
      }), /*#__PURE__*/_react["default"].createElement(_reactIdSwiper["default"], (0, _extends2["default"])({}, settings, this.state), images.map(function (image) {
        return /*#__PURE__*/_react["default"].createElement(StyledGaleryItem, {
          className: "swiper-lazy",
          height: imageHeight,
          width: imageWidth,
          "data-background": (0, _userflow.getFullUrl)(image),
          key: image,
          onClick: function onClick() {
            return onClickGallery(id);
          }
        }, /*#__PURE__*/_react["default"].createElement(StyledLoaderIcon, {
          className: "swiper-lt-preloader"
        }));
      })));
    }
  }]);
}(_react["default"].PureComponent);
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "MobileRoomGallery__StyledContainer",
  componentId: "sc-113j93z-0"
})(["position:relative;width:100%;"]);
var StyledLoaderIcon = (0, _styledComponents["default"])(_Loader["default"]).withConfig({
  displayName: "MobileRoomGallery__StyledLoaderIcon",
  componentId: "sc-113j93z-1"
})(["animation:var(--loader-animation);height:24px;path{fill:var(--white);}"]);
MobileRoomGallery.propTypes = {
  children: _propTypes["default"].node.isRequired,
  imageHeight: _propTypes["default"].number,
  imageWidth: _propTypes["default"].number,
  images: _propTypes["default"].arrayOf(_propTypes["default"].string),
  className: _propTypes["default"].string
};
MobileRoomGallery.defaultProps = {
  imageWidth: 180,
  imageHeight: 170,
  className: '',
  images: []
};
var StyledArrowIcon = (0, _styledComponents["default"])(ArrowIcon).withConfig({
  displayName: "MobileRoomGallery__StyledArrowIcon",
  componentId: "sc-113j93z-2"
})(["position:absolute;right:0;cursor:pointer;height:70px;width:30px;z-index:10;top:calc(50% - 35px);left:", ";right:", ";transform:rotate(", ");&.swiper-button-disabled{opacity:0.35;cursor:auto;pointer-events:none;}"], function (props) {
  return props.type === 'prev' ? 0 : 'auto';
}, function (props) {
  return props.type === 'next' ? 0 : 'auto';
}, function (props) {
  return props.type === 'prev' ? '180deg' : '0deg';
});
var StyledGaleryItem = _styledComponents["default"].div.withConfig({
  displayName: "MobileRoomGallery__StyledGaleryItem",
  componentId: "sc-113j93z-3"
})(["height:", " !important;width:", " !important;vertical-align:top;background-color:#f5f3f2;background-size:cover;"], function (props) {
  return "".concat(props.height, "px");
}, function (props) {
  return "".concat(props.width, "px");
});
var _default = exports["default"] = MobileRoomGallery;